import {useMemo} from "react";

import {IComparisonTableElement} from "../types/IComparisonTableElement";
import {IComparisonTableRow} from "../types/IComparisonTableRow";
import {IComparisonTableScrollDirection} from "../types/IComparisonTableScrollDirection";
import {useComparisonTableRefs} from "./use_comparison_table_refs";
import {useScrollNavigation} from "./use_scroll_navigation";
import {useSyncScroll} from "./use_sync_scroll";
import {useThemeDefaults} from "./use_theme_defaults";

interface IProps<TTableItemData extends IComparisonTableElement> {
    rows: IComparisonTableRow<TTableItemData>[];
    onScrollLeft?: () => void;
    onScrollRight?: () => void;
}

export const useComparisonTable = <TTableItemData extends IComparisonTableElement>({rows, onScrollLeft, onScrollRight}: IProps<TTableItemData>) => {
    const {tableRef, tableRowsRef, headerRef} = useComparisonTableRefs();
    const {tableScroll, tableScrollToSpecificValue} = useScrollNavigation({tableRef, headerRef, tableRowsRef});
    const tableSettings = useThemeDefaults();
    useSyncScroll({tableRef, headerRef});

    const handleScrollLeft = () => {
        tableScroll(IComparisonTableScrollDirection.LEFT);
        onScrollLeft?.();
    };

    const handleScrollRight = () => {
        tableScroll(IComparisonTableScrollDirection.RIGHT);
        onScrollRight?.();
    };

    return useMemo(() => {
        const tableNavigation = {
            scrollLeft: () => {
                handleScrollLeft();
            },
            scrollRight: () => {
                handleScrollRight();
            },
            tableScrollToSpecificValue
        };

        return {
            tableProps: {
                refs: {
                    headerRef,
                    tableRef,
                    tableRowsRef
                },
                rows,
                tableScroll,
                tableSettings,
                tableNavigation
            },
            tableSettings,
            tableNavigation
        };
    }, [headerRef, tableRef, tableRowsRef, rows, tableScroll, tableScrollToSpecificValue]);
};

export type IUseComparisonTableReturnType<TTableItemData extends IComparisonTableElement> = ReturnType<typeof useComparisonTable<TTableItemData>>;
import {useMemo} from "react";

import {IComparisonTableElement} from "../types/IComparisonTableElement";
import {IComparisonTableRow} from "../types/IComparisonTableRow";
import {IComparisonTableScrollDirection} from "../types/IComparisonTableScrollDirection";
import {useComparisonTableRefs} from "./use_comparison_table_refs";
import {useScrollNavigation} from "./use_scroll_navigation";
import {useSyncScroll} from "./use_sync_scroll";
import {useThemeDefaults} from "./use_theme_defaults";

interface IProps<TTableItemData extends IComparisonTableElement> {
    rows: IComparisonTableRow<TTableItemData>[];
    onScrollLeft?: () => void;
    onScrollRight?: () => void;
}

export const useComparisonTable = <TTableItemData extends IComparisonTableElement>({rows, onScrollLeft, onScrollRight}: IProps<TTableItemData>) => {
    const {tableRef, tableRowsRef, headerRef} = useComparisonTableRefs();
    const {tableScroll, tableScrollToSpecificValue} = useScrollNavigation({tableRef, headerRef, tableRowsRef});
    const tableSettings = useThemeDefaults();
    useSyncScroll({tableRef, headerRef});

    const handleScrollLeft = () => {
        tableScroll(IComparisonTableScrollDirection.LEFT);
        onScrollLeft?.();
    };

    const handleScrollRight = () => {
        tableScroll(IComparisonTableScrollDirection.RIGHT);
        onScrollRight?.();
    };

    return useMemo(() => {
        const tableNavigation = {
            scrollLeft: () => {
                handleScrollLeft();
            },
            scrollRight: () => {
                handleScrollRight();
            },
            tableScrollToSpecificValue
        };

        return {
            tableProps: {
                refs: {
                    headerRef,
                    tableRef,
                    tableRowsRef
                },
                rows,
                tableScroll,
                tableSettings,
                tableNavigation
            },
            tableSettings,
            tableNavigation
        };
    }, [headerRef, tableRef, tableRowsRef, rows, tableScroll, tableScrollToSpecificValue]);
};

export type IUseComparisonTableReturnType<TTableItemData extends IComparisonTableElement> = ReturnType<typeof useComparisonTable<TTableItemData>>;
